const PRINT_CSS = "body{font-family:Georgia,serif;margin:2cm;color:#111;line-height:1.55}h1,h2,h3,h4,h5,h6{font-family:sans-serif;line-height:1.25;margin:1.1rem 0 .4rem}p{margin:.45rem 0}ul,ol{margin:.4rem 0;padding-left:1.4rem}blockquote{margin:.7rem 0;padding-left:.9rem;border-left:3px solid #cbd5e1}pre{white-space:pre-wrap;background:#f8fafc;padding:.6rem .8rem;border-radius:.4rem}code{font-family:ui-monospace,monospace}table{border-collapse:collapse;width:100%;margin:.6rem 0}td,th{border:1px solid #cbd5e1;padding:.35rem .5rem;vertical-align:top}img,video{max-width:100%;height:auto}hr{border:0;border-top:1px solid #cbd5e1;margin:1rem 0}a{color:#1d4ed8}";

export function printHtml(title: string, html: string): void {
  writePrint(title, html);
}

export function printPlain(title: string, body: string): void {
  writePrint(title, `<pre>${escapeHtml(body)}</pre>`);
}

function writePrint(title: string, html: string): void {
  const frame = document.createElement("iframe");
  frame.setAttribute("title", "Impression");
  frame.style.cssText = "position:fixed;width:0;height:0;border:0;visibility:hidden";
  document.body.appendChild(frame);
  const doc = frame.contentDocument;
  const win = frame.contentWindow;
  if (!doc || !win) {
    frame.remove();
    throw new Error("Impression impossible.");
  }
  const safeTitle = escapeHtml(title);
  doc.open();
  doc.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${safeTitle}</title><style>${PRINT_CSS}</style></head><body><h1>${safeTitle}</h1>${html}</body></html>`);
  doc.close();
  win.focus();
  win.print();
  window.setTimeout(() => frame.remove(), 1200);
}

function escapeHtml(value: string): string {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
